import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=159a2150&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports